<template>
  <div v-show="show" :class="className" class="notification is-flash">
    <strong v-if="isSuccess">
      Success!
    </strong>
    <strong v-if="isError">
      Error !
    </strong>
    <span v-html="body" />
  </div>
</template>

<script>
export default {
  name: 'Flash',
  props: {
    message: { type: String, default: '' },
    type: { type: String, default: 'success' }
  },

  data() {
    return {
      flash_type: this.type,
      body: '',
      show: false
    };
  },

  computed: {
    isSuccess() {
      return this.flash_type === 'success';
    },
    isError() {
      return this.flash_type === 'error';
    },
    className() {
      if (this.isSuccess) {
        return 'is-primary';
      }

      if (this.isError) {
        return 'is-danger';
      }

      return null;
    }
  },

  created() {
    if (this.message) {
      this.flash(this.message);
    }

    window.VueEventHub.$on('flash', (message, type) => {
      if (!type) {
        type = 'success';
      }
      this.flash(message, type);
    });

    window.VueEventHub.$on('error', message => {
      this.flash_type = 'error';
      this.flash(message);
    });
  },

  methods: {
    flash(message,type) {
      if (type) {
        this.flash_type = type;
      }
      this.body = message;
      this.show = true;

      this.hide();
    },

    hide() {
      setTimeout(() => {
        this.show = false;
      }, 3000);
    }
  }
};
</script>
